import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export function Label({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <label className={cn('mb-1.5 block text-sm font-semibold text-neutral-800', className)}>
      {children}
    </label>
  )
}

export function Hint({ children }: { children: ReactNode }) {
  return <p className="mt-1 text-xs text-neutral-400">{children}</p>
}

const fieldClass =
  'w-full rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-neutral-800 placeholder:text-neutral-400 focus:border-brand-300 focus:outline-none'

export function TextInput({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cn(fieldClass, className)} {...props} />
}

export function TextArea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea className={cn(fieldClass, 'resize-none leading-relaxed', className)} {...props} />
  )
}

export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-400',
        className,
      )}
    >
      {children}
    </div>
  )
}
